import { switchMap } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ParticipantTypeEnum } from '../../_shared/models/csTypes/enums/participant_type';
import { ParticipantListService } from '../participant-list.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, scan, startWith, Subject, combineLatest } from 'rxjs';
import { Participant } from '../../_shared/models/participant';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-select-participant',
  templateUrl: './select-participant.component.html',
  styleUrls: ['./select-participant.component.scss'],
  standalone: true,
  imports: [
    IonicModule
  ]
})
export class SelectParticipantComponent {
  participantListService = inject(ParticipantListService);
  modalController = inject(ModalController);

  @Input({ required: true }) participantType!: ParticipantTypeEnum;
  @Input({ required: true }) _tournamentId!: string;

  getParticipants$ = new Subject<void>();
  filter$ = new Subject<{op: string, value: string}>();

  participants$ = this.getParticipants$.pipe(
    switchMap(() => this.participantListService.getTournamentParticipants(this.participantType, this._tournamentId))
  )

  participantsData$ = combineLatest([
    this.participants$,
    this.filter$.pipe(startWith(null))
  ]).pipe(
    scan((
      _,
      [participants, filter]: [Participant[], { op: string; value: string } | null]
    ): Participant[] => {
      let filteredParticipants = [...participants]; // Create a copy to ensure immutability

      // Apply additional filtering if there's a filter value
      if (filter && filter.op === 'filter' && filter.value) {
        filteredParticipants = filteredParticipants.filter(participant =>
          participant.displayName?.toLowerCase().includes(filter.value.toLowerCase())
        );
      }

      return filteredParticipants; // Return the filtered array directly
    }, [] as Participant[]), // Ensure correct initialization type

    // Ensure the final mapping and type are consistent
    map((participants: Participant[]) => participants)
  );

  participants = toSignal(this.participantsData$);

  constructor() {}

  ngOnInit() {
    this.getParticipants$.next();
  }

  getItems(ev) {
    // set val to the value of the ev target
    const val = ev.target.value;
    this.filter$.next({op: 'filter', value: val})
  }

  async selectParticipant(participant: Participant) {
    await this.modalController.dismiss(participant)
  }

  async close() {
    await this.modalController.dismiss()
  }


}
